export const setupStopReferrerHack = (): void => {
  document.querySelectorAll('a[target="_blank"], a[target="new"]').forEach((link) => {
    link.setAttribute('rel', 'noopener noreferrer');
  });
};
